import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static values = { url: String };
  static targets = ["numberInput", "checkbox"];

  connect() {
    this._boundSaveIfChanged = this._saveIfChanged.bind(this);

    if (this.hasNumberInputTarget) {
      this.numberInputTarget.addEventListener("blur", this._boundSaveIfChanged);
      this.numberInputTarget.addEventListener("change", this._boundSaveIfChanged);
    }

    this._lastSavedDays = this.hasNumberInputTarget ? this.numberInputTarget.value : "";
  }

  disconnect() {
    if (this.hasNumberInputTarget) {
      this.numberInputTarget.removeEventListener("blur", this._boundSaveIfChanged);
      this.numberInputTarget.removeEventListener("change", this._boundSaveIfChanged);
    }
  }

  _saveIfChanged(event) {
    const currentDays = event?.detail?.value !== undefined
      ? String(event.detail.value)
      : (this.hasNumberInputTarget ? this.numberInputTarget.value : "");

    if (currentDays === this._lastSavedDays) return;

    this._selectCheckbox();
    this._lastSavedDays = currentDays;
    this.saveDates(currentDays);
  }

  _selectCheckbox() {
    if (this.hasCheckboxTarget && !this.checkboxTarget.checked) {
      this.checkboxTarget.checked = true;
    }
  }

  saveDates(days) {
    const body = new FormData();

    if (days === undefined) {
      days = this.hasNumberInputTarget ? this.numberInputTarget.value : "";
    }

    if (days !== "" && days !== undefined) {
      body.append("task[date_reference_attributes][offset]", `${days} days`);
      body.append("task[date_reference_attributes][anchor]", "start_at");
    } else {
      body.append("task[date_reference_attributes][_destroy]", "1");
    }

    this._lastSavedDays = days;

    Rails.ajax({
      url: this.urlValue,
      type: "PATCH",
      data: body,
      headers: {
        'Content-Type': 'application/json'
      },
      dataType: "script",
      success: (res) => {}
    });
  }

  clearDates() {
    const datePickerInput = this.element.querySelector(
      '[name="task[date_reference_attributes][calendar]"]'
    );

    if (datePickerInput) {
      datePickerInput.dispatchEvent(
        new CustomEvent("promote:datepicker-change", { detail: { value: "" } })
      );
    }

    if (this.hasNumberInputTarget) this.numberInputTarget.value = "";

    this.saveDates();
  }
}
